//
//
//
//

const fusetag = window.fusetag

export default {
    name: 'PubliftAdController',

    methods: {
        /**
         * This is called by the router whenever the page is changed. It is not
         * when the router detects the URL changed but the page hasn't
         * (i.e. when clicking on different groups).
         */
        pageChanged(to, from) { // eslint-disable-line no-unused-vars
            this.createOrUpdateAds()
        },

        createOrUpdateAds() {
            fusetag.que.push(() => {
                fusetag.pageInit({})
            })
        },
    },

    mounted() {
        this.createOrUpdateAds()

        this.$listenFor('pageChanged', this.pageChanged)
    },
}
